import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { Persone_List_Interface } from 'src/app/Interface/Persone_List_Interface';
import { Empty_Person_Interface, Person_Interface } from 'src/app/Interface/Person_Interface';
import { QUANTITY_Interface } from 'src/app/Interface/QUANTITY_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { PersonService } from 'src/app/Service/Person/Person.service';
import { QUANTITYService } from 'src/app/Service/QUANTITY/QUANTITY.service';

@Component({
  selector: 'app-QUANTITYController',
  templateUrl: './QUANTITYController.component.html',
  styleUrls: ['./QUANTITYController.component.css']
})
export class QUANTITYControllerComponent implements OnInit {

  Token: String = ""
  Procssing_Personel:boolean=false
  @Input() inner_quantity_Record: General_Interface
  DataList_Person_Quantity: Array<Person_Interface> = []
  Data_Seleted_Delete : Person_Interface=Empty_Person_Interface()
  modalRef_Delete: any

  constructor(
    private Quantity_Service:QUANTITYService,
    private Alertify_Service:AlertifyService,
    private Person_Service:PersonService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Read_Person_Quantity()
  }


  Read_Person_Quantity() {
    this.Procssing_Personel = true

    this.Quantity_Service.GetController(this.Token, this.inner_quantity_Record.id).subscribe(
      data => {
        this.DataList_Person_Quantity = data
        this.Procssing_Personel=false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  Set_Selected_Personel_Record(item: Persone_List_Interface)
  {
    this.modalRef_Personel.hide()
    this.Procssing_Personel=true
    this.Quantity_Service.PostController(this.inner_quantity_Record.id, this.Token, item.id).subscribe(
      data => {
        this.Procssing_Personel=false

        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage("The selected person has already been added")
        }
        else {
          this.Read_Person_Quantity()
          this.Alertify_Service.SuccessMessage("The information was registered successfully")
        }
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }


  Delete() {
    this.Procssing_Personel=true
    this.modalRef_Delete.hide()
    this.Quantity_Service.DeleteController(this.Data_Seleted_Delete.id, this.Token).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("Deleted successfully")
        this.Read_Person_Quantity()
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  openModal(template: TemplateRef<any>, Record:Person_Interface) {
    this.Data_Seleted_Delete = Record
    this.modalRef_Delete = this.modalService.show(template);
  }


  //#region Person

  Personel_List:Array<Persone_List_Interface>=[]
  modalRef_Personel: any

  Filter_Familly: String = ''
  Personelpage:number=0
  openModal_Personeln(template: TemplateRef<any>) {
    this.modalRef_Personel = this.modalService.show(template);
  }

  Read_Personel() {
    this.Procssing_Personel=true
    this.Person_Service.GetHasUser(this.Token).subscribe(
      data => {
        this.Procssing_Personel=false
        this.Personel_List=data
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  Change_Filter() {
    this.Personelpage = 0
  }

  //#endregion

}
